import React, { useMemo } from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { LegalDocument } from './LegalDocument';
import { legalDocumentForLocale } from '../utils/legal-documents';

import privacyEn from '../content/privacy-policy-en.md?raw';
import privacyEs from '../content/privacy-policy-es.md?raw';
import privacyFr from '../content/privacy-policy-fr.md?raw';
import privacyDe from '../content/privacy-policy-de.md?raw';
import privacyCa from '../content/privacy-policy-ca.md?raw';

export const PrivacyPolicy: React.FC = () => {
  const { locale } = useLocale();
  const content = useMemo(
    () =>
      legalDocumentForLocale(locale, {
        en: privacyEn,
        es: privacyEs,
        fr: privacyFr,
        de: privacyDe,
        ca: privacyCa,
      }),
    [locale],
  );

  return <LegalDocument content={content} />;
};
